<script setup>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
</script>

<template>
  <div class="app-container">
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<style>
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.form-title {
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  margin: 24px 0px;
  color: #ffffff;
}

@media (max-width: 768px) {
  .form-title {
    font-size: 32px;
  }
}
</style>
